import { createAction } from '@reduxjs/toolkit';
import { Organization } from '../models/organization.model';

export const FETCH_CONTEXT = '[OrganizationInfo] FETCH_CONTEXT';
export const STORE_CONTEXT = '[OrganizationInfo] STORE_CONTEXT';

export const fetchOrganizationAction = createAction<string>(FETCH_CONTEXT);
export const storeOrganizationAction = createAction<Organization>(STORE_CONTEXT);
